const WalletConnectIcon = ({ props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 86.926 53.099"
    {...props}
  >
    <g id="Layer_x0020_1" transform="translate(-22.852 -38.824)">
      <g id="_2806050136896" transform="translate(0.31 0.001)">
        <path
          id="Path_2457"
          data-name="Path 2457"
          d="M446.051,744.629a36.98,36.98,0,0,1,51.376,0l1.7,1.644a1.76,1.76,0,0,1,0,2.492l-5.832,5.673a.866.866,0,0,1-1.272,0l-2.333-2.28a25.806,25.806,0,0,0-35.841,0l-2.492,2.439a.866.866,0,0,1-1.272,0l-5.832-5.673a1.76,1.76,0,0,1,0-2.492l1.856-1.8Zm63.412,11.77,5.2,5.09a1.76,1.76,0,0,1,0,2.492l-23.435,22.852a1.825,1.825,0,0,1-2.545,0l-16.648-16.224a.484.484,0,0,0-.636,0l-16.648,16.224a1.825,1.825,0,0,1-2.545,0l-23.435-22.852a1.76,1.76,0,0,1,0-2.492l5.2-5.09a1.824,1.824,0,0,1,2.545,0l16.648,16.224a.484.484,0,0,0,.636,0L470.441,756.4a1.824,1.824,0,0,1,2.545,0l16.648,16.224a.484.484,0,0,0,.636,0L506.918,756.4a1.824,1.824,0,0,1,2.545,0Z"
          transform="translate(-405.708 -695.426)"
          fill="#637eea"
        />
      </g>
    </g>
  </svg>
);

export default WalletConnectIcon;
